import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { ENVIRONMENT, Environment } from "@vattenfall/core";

import { FlowsFIRenewalLoginModel, LoginOrderResponse } from "./flows-fi-renewal-login.element.model";

@Injectable({
  providedIn: "root",
})
export class FlowsFIRenewalLoginService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject(ENVIRONMENT)
    private environment: Environment
  ) {}

  public submitSignIn(body: FlowsFIRenewalLoginModel) {
    return this.http.post<LoginOrderResponse>(`${this.environment.endpoints.finlandApi}/ValidateUserLogin`, {
      customerNumber: body.customerno,
      agreementNumber: body.agreementno,
    });
  }
}
